module.exports = __webpack_public_path__ + "img/Groundscope.a0cdc7e9.jpg";